import { render, staticRenderFns } from "./HrEmployeeRetire.vue?vue&type=template&id=20478c3f&scoped=true&"
import script from "./HrEmployeeRetire.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeRetire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20478c3f",
  null
  
)

export default component.exports